<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex x16>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              type="search"
              append-icon="search"
              label="Search"
              single-line hide-details
            > </v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mr-0"
              @click="openModalCreate"
            > New client </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="clients"
            class="elevation-5"
            :pagination.sync="pagination"
            :search="search"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.identifier }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                <div class="color" :style="{ 'backgroundColor': props.item.color }"></div>
              </td>
              <td>{{ props.item.logo ? 'Yes' : 'No' }}</td>
              <td>{{ props.item.background ? 'Yes' : 'No' }}</td>
              <td>
                <div class="text-center d-flex">
                  <v-btn class="mr-0" icon @click="openModalEdit(props.item)">
                    <v-icon color="primary">edit</v-icon>
                  </v-btn>
                  <v-btn icon @click="openModalDestroy(props.item)">
                    <v-icon color="red">delete</v-icon>
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <modal-client></modal-client>
    <modal-delete></modal-delete>
  </v-container>
</template>
<script>
import ModalClient from './ModalCreateEdit.vue';
import ModalDelete from './ModalDelete.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ModalClient,
    ModalDelete
  },
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Identifier',
          value: 'identifier'
        },
        {
          text: 'Description',
          value: 'description'
        },
        {
          text: 'Color',
          value: 'color'
        },
        {
          text: 'Logo',
          value: 'logo'
        },
        {
          text: 'Background',
          value: 'background'
        },
        {
          text: 'actions',
          value: false,
          align: 'center'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['loading', 'clients', 'client'])
  },
  watch: {
  },
  mounted () {
    this.loadData();
  },
  methods: {
    openModalCreate (client, index) {
      this.$store.dispatch('setTitleModalClient', 'Create new client');
      this.$store.dispatch('setClient', {});
      this.$store.dispatch('setClientIndex', false);
      this.$store.dispatch('setOpenModalclient', true);
    },
    openModalEdit (client) {
      this.$store.dispatch('setTitleModalClient', 'Edit client');
      this.$store.dispatch('setClientIndex', true);
      this.$store.dispatch('setClient', client);
      this.$store.dispatch('setNameClient', client.name);
      this.$store.dispatch('setIdentifierClient', client.identifier);
      this.$store.dispatch('setDescriptionClient', client.description);
      this.$store.dispatch('setColorClient', client.color);
      this.$store.dispatch('setOpenModalclient', true);
    },
    openModalDestroy (client) {
      this.$store.dispatch('setClient', client);
      this.$store.dispatch('setOpenModalClientDestroy', true);
    },
    loadData () {
      this.$store.commit('setLoading', true);
      let url = '/clients/list';
      window.axios.get(url).then((response) => {
        this.$store.dispatch('setClients', response.data.data);
        this.$store.commit('setLoading', false);
      });
    },
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/clients/List.vue